"use client";

import Icon from "@/components/ui/AppIcon";
import { useLanguage } from "@/context/LanguageContext";

export default function WhyChooseSection() {
  const { t } = useLanguage();

  const features = [
    { id: "feat_authentic", icon: "CheckBadgeIcon" as const, titleKey: "why_f1_title" as const, descKey: "why_f1_desc" as const },
    { id: "feat_handmade", icon: "HandRaisedIcon" as const, titleKey: "why_f2_title" as const, descKey: "why_f2_desc" as const },
    { id: "feat_shipping", icon: "TruckIcon" as const, titleKey: "why_f3_title" as const, descKey: "why_f3_desc" as const },
    { id: "feat_payment", icon: "ShieldCheckIcon" as const, titleKey: "why_f4_title" as const, descKey: "why_f4_desc" as const },
    { id: "feat_support", icon: "ChatBubbleLeftRightIcon" as const, titleKey: "why_f5_title" as const, descKey: "why_f5_desc" as const },
    { id: "feat_returns", icon: "ArrowPathIcon" as const, titleKey: "why_f6_title" as const, descKey: "why_f6_desc" as const },
  ];

  return (
    <section className="py-20 md:py-32 bg-muted/30">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16 reveal will-animate">
          <span className="text-primary font-semibold text-sm uppercase tracking-wider">
            {t("why_badge")}
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-foreground mt-4 mb-6">
            {t("why_title")}
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            {t("why_desc")}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={feature.id}
              className="reveal will-animate bg-card p-8 rounded-2xl shadow-md hover:shadow-xl transition-all group"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors">
                <Icon name={feature.icon} size={32} className="text-primary" variant="solid" />
              </div>
              <h3 className="text-xl font-bold text-foreground mb-3">{t(feature.titleKey)}</h3>
              <p className="text-muted-foreground leading-relaxed">{t(feature.descKey)}</p>
            </div>
          ))}
        </div>

        {/* Trust Badges */}
        <div className="mt-16 flex flex-wrap justify-center items-center gap-8 reveal will-animate">
          <div className="flex items-center gap-3 px-6 py-3 bg-card rounded-full shadow-md">
            <Icon name="LockClosedIcon" size={24} className="text-success" variant="solid" />
            <span className="font-semibold text-sm text-foreground">{t("why_ssl")}</span>
          </div>
          <div className="flex items-center gap-3 px-6 py-3 bg-card rounded-full shadow-md">
            <Icon name="ShieldCheckIcon" size={24} className="text-success" variant="solid" />
            <span className="font-semibold text-sm text-foreground">{t("why_verified")}</span>
          </div>
          <div className="flex items-center gap-3 px-6 py-3 bg-card rounded-full shadow-md">
            <Icon name="TruckIcon" size={24} className="text-success" />
            <span className="font-semibold text-sm text-foreground">{t("why_free_ship")}</span>
          </div>
        </div>
      </div>
    </section>
  );
}